import { PathRender } from '../../renders/Path';
import { Canvas } from "./Canvas";
/**
 * @alias sGis.painter.domPainter.CanvasGroupRenderer
 * @ignore
 */
export class CanvasGroupRenderer {
    constructor(canvasContainer, domPainter) {
        this.canvasGroups = [];
        this.canvasContainer = canvasContainer;
        this.domPainter = domPainter;
    }
    setIndex(index) {
        if (this.zIndex !== index) {
            for (let canvasGroup of this.canvasGroups) {
                if (canvasGroup.canvas) {
                    canvasGroup.canvas.setIndex(index + 1);
                }
            }
            this.zIndex = index + 1;
        }
    }
    removeCanvas(canvas) {
        if (this.canvasContainer)
            this.canvasContainer.removeNode(canvas.node);
    }
    resetCanvas(canvas, bbox) {
        this.removeCanvas(canvas);
        canvas.reset(bbox, this.domPainter.map.resolution, this.domPainter.width, this.domPainter.height);
    }
    drawRender(canvas, render) {
        canvas.draw(render, this.domPainter.map);
    }
    addCanvasToDom(canvas, bbox) {
        this.canvasContainer.addNode(canvas.node, canvas.width, canvas.height, bbox);
    }
    clear() {
        for (let i = 0; i < this.canvasGroups.length; i++) {
            const { canvas } = this.canvasGroups[i];
            if (canvas && canvas.node.parentNode) {
                this.canvasContainer.removeNode(canvas.node);
            }
            this.canvasGroups[i] = {
                canvas: null,
                render: null,
                updateNeeded: false,
            };
        }
    }
    moveToContainer(canvasContainer) {
        for (let canvasGroup of this.canvasGroups) {
            const { canvas } = canvasGroup;
            if (canvas && canvas.node.parentNode) {
                this.canvasContainer.removeNode(canvas.node);
                canvasContainer.addNode(canvas.node, canvas.width, canvas.height, canvas.bbox);
            }
        }
        this.canvasContainer = canvasContainer;
    }
    render(renders) {
        var _a;
        if (this.canvasGroups.length === 0) {
            this.canvasGroups = new Array(renders.length);
        }
        const canvasGroupsToRender = [];
        for (let i = 0; i < renders.length; i++) {
            const canvas = ((_a = this.canvasGroups[i]) === null || _a === void 0 ? void 0 : _a.canvas) || new Canvas();
            canvas.setIndex(renders[i] instanceof PathRender ? this.zIndex + 1 : this.zIndex);
            this.canvasGroups[i] = {
                canvas: canvas,
                render: renders[i],
                updateNeeded: renders[i].updateNeeded,
            };
            canvasGroupsToRender.push({
                canvas: canvas,
                render: renders[i],
                updateNeeded: renders[i].updateNeeded,
            });
        }
        const bbox = this.domPainter.bbox;
        const activeCanvasGroups = this.canvasGroups.filter(({ canvas }) => !!canvas);
        for (let i = 0; i < activeCanvasGroups.length - renders.length; i++) {
            const canvas = activeCanvasGroups[activeCanvasGroups.length - 1 - i].canvas;
            this.resetCanvas(canvas, bbox);
        }
        const canvasGroupsToUpdate = canvasGroupsToRender.filter(({ updateNeeded }) => updateNeeded);
        for (let canvasGroup of canvasGroupsToUpdate) {
            this.resetCanvas(canvasGroup.canvas, bbox);
            this.drawRender(canvasGroup.canvas, canvasGroup.render);
            if (!canvasGroup.canvas.isEmpty) {
                this.addCanvasToDom(canvasGroup.canvas, bbox);
            }
        }
    }
}
